import { makeStyles } from '@material-ui/core';

import { COLOR_ICON_INACTIVE, COLORS, FONTS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      width: 266,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(2, 2, 3),
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,
      boxShadow: '0px 3px 20px rgba(117, 117, 117, 0.12)',
      marginRight: theme.spacing(-2),
    },
    title: {
      fontFamily: FONTS.DMSans,
      textAlign: 'center',
    },

    bannerImage: {
      width: 132,
      height: 122,
      marginBottom: theme.spacing(1),
    },
    buttonClose: {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: theme.spacing(1),

      '& svg': {
        fontSize: theme.typography.pxToRem(16),
        color: COLOR_ICON_INACTIVE,
      },
    },
    button: {
      marginTop: theme.spacing(1.5),
      padding: theme.spacing(1, 2),
    },
  }),
  { name: 'DDUpgradePanel' }
);
